function long2day(time) {
  if (!time) {
    return "";
  }
  let date = new Date(time);
  let info = "";

  info += date.getFullYear() + ".";

  if (date.getMonth() + 1 < 10) {
    info += "0" + (date.getMonth() + 1) + ".";
  } else {
    info += "" + (date.getMonth() + 1) + ".";
  }

  if (date.getDate() < 10) {
    info += "0" + date.getDate() + "";
  } else {
    info += "" + date.getDate() + "";
  }

  return info;
}

function long2second(time) {
  if (!time) {
    return "";
  }
  let date = new Date(time);
  let info = "";

  info += date.getFullYear() + ".";

  if (date.getMonth() + 1 < 10) {
    info += "0" + (date.getMonth() + 1) + ".";
  } else {
    info += "" + (date.getMonth() + 1) + ".";
  }

  if (date.getDate() < 10) {
    info += "0" + date.getDate() + " ";
  } else {
    info += "" + date.getDate() + " ";
  }

  if (date.getHours() < 10) {
    info += "0" + date.getHours() + ":";
  } else {
    info += "" + date.getHours() + ":";
  }

  if (date.getMinutes() < 10) {
    info += "0" + date.getMinutes() + ":";
  } else {
    info += "" + date.getMinutes() + ":";
  }

  if (date.getSeconds() < 10) {
    info += "0" + date.getSeconds() + "";
  } else {
    info += "" + date.getSeconds() + "";
  }

  return info;
}

function funDownload(url, name) {
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
}

function convertRes2Blob(filename, response) {
  // 将二进制流转为blob
  const blob = new Blob([response.data], { type: "application/octet-stream" });
  if (typeof window.navigator.msSaveBlob !== "undefined") {
    // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
    window.navigator.msSaveBlob(blob, decodeURI(filename));
  } else {
    // 创建新的URL并指向File对象或者Blob对象的地址
    const blobURL = window.URL.createObjectURL(blob);
    // 创建a标签，用于跳转至下载链接
    const tempLink = document.createElement("a");
    tempLink.style.display = "none";
    tempLink.href = blobURL;
    tempLink.setAttribute("download", decodeURI(filename));
    // 兼容：某些浏览器不支持HTML5的download属性
    if (typeof tempLink.download === "undefined") {
      tempLink.setAttribute("target", "_blank");
    }
    // 挂载a标签
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    // 释放blob URL地址
    window.URL.revokeObjectURL(blobURL);
  }
}

const userInfo = {};
const item = {};

export default {
  long2day,
  funDownload,
  long2second,
  userInfo,
  item,
  convertRes2Blob
};
